/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Vibebids_Days_AgoInputs */

const en_directory_vibebids_days_ago = /** @type {(inputs: Directory_Vibebids_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} days ago`)
};

const zh_directory_vibebids_days_ago = /** @type {(inputs: Directory_Vibebids_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 天前`)
};

/**
* | output |
* | --- |
* | "{count} days ago" |
*
* @param {Directory_Vibebids_Days_AgoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_days_ago = /** @type {((inputs: Directory_Vibebids_Days_AgoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Days_AgoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_days_ago(inputs)
	return zh_directory_vibebids_days_ago(inputs)
});
export { directory_vibebids_days_ago as "directory.vibebids.days_ago" }